import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

const TextEditorTitleWrapper = ({ theme, ...rest }) => <div className={get(theme, 'container')} {...rest}/>;

TextEditorTitleWrapper.propTypes = {
  theme: PropTypes.object,
};

export default TextEditorTitleWrapper;



// WEBPACK FOOTER //
// ./app/components/text-editor/text-editor-title-wrapper.js